window.gaLinkPush = function(event, eventCategory, eventAction) {
    event.preventDefault();

    let target = event.target.closest('a')

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        'event' : 'autoEvent',
        'eventCategory' : eventCategory,
        'eventAction' : eventAction,
        'eventCallback' : function() {
            window.location = target.getAttribute('href');
        },
        'eventTimeout' : 2000
    });
}

window.gaPush = function(event, eventCategory, eventAction) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
        'event' : 'autoEvent',
        'eventCategory' : eventCategory,
        'eventAction' : eventAction,
    });
}